import { Action } from 'redux'
import { ReservationModalActions } from '../../../reducers/bookingCalendar/actionNames'

const selectReservationTab = (index): ISelectTab => ({
  tab: index,
  type: ReservationModalActions.SetTab,
})

export default selectReservationTab

export interface ISelectTab extends Action<ReservationModalActions.SetTab> {
  tab: number
}
